import React from "react";
import { useCompanyDetailsContext } from "../../context/CompanyDetailsContext";

const Map = () => {
    const { companyDetailsData } = useCompanyDetailsContext();
  return (
    <section className="contact-page-google-map">
      <iframe
        src={companyDetailsData[0]?.attributes?.Map}
        className="contact-page-google-map__one"
        allowFullScreen
        title="address"
      ></iframe>
    </section>
  );
};

export default Map;
